import config from 'config';

import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
// Components
import { QRCodeCanvas } from "qrcode.react";

type Props = {
  isLargeScreen: boolean;
  isCompact?: boolean;
}

const QRCode:FC<Props> = ({ isLargeScreen, isCompact = false }) => {
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;

  if (!quiz || !quiz.publicLeaderboard.quizQRCodeEnabled) return null;

  if (isCompact) {
    return (
      <div className="flex-1 min-w-0 min-h-0 flex flex-col items-center justify-center gap-1">
        <div className="flex-1 min-h-0 w-full flex items-center justify-center">
          <div className="aspect-square h-full max-w-full flex flex-col p-1 bg-white text-black rounded-xl">
            <QRCodeCanvas
              value={qrCodeLink}
              level="H"
              size={128}
              style={{ width: '100%', height: '100%' }}
              imageSettings={{
                src: quiz.publicLeaderboard.quizQRCodeLogo || '',
                width: 40,
                height: 40,
                excavate: true
              }}
            />
          </div>
        </div>
        <h2
          className="shrink-0 w-full truncate italic uppercase text-xs font-extrabold text-center"
          style={{
            background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {quiz?.publicLeaderboard.quizQRCodeTitle}
        </h2>
      </div>
    );
  }

  return (
    <div className="flex landscape:items-end portrait:justify-center">
      <div className="flex flex-col items-center">
        <div className="mb-4 flex flex-col gap-2 p-2 bg-white text-black rounded-xl w-max xl:p-4" style={{ width: '100% !important' }}>
          <QRCodeCanvas
            value={qrCodeLink}
            level="H"
            size={isLargeScreen ? 400 : 128}
            imageSettings={{
              src: quiz.publicLeaderboard.quizQRCodeLogo || '',
              width: isLargeScreen ? 120 : 40,
              height: isLargeScreen ? 120 : 40,
              excavate: true
            }}
          />
        </div>

        <div className="relative">
          <h2
            className="relative pr-3 italic uppercase text-lg font-extrabold text-center sm:text-5xl z-10"
            style={{
              background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {quiz?.publicLeaderboard.quizQRCodeTitle}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default QRCode;
